import { render, staticRenderFns } from "./FormSelectMaterial.vue?vue&type=template&id=b01dbc7a&scoped=true"
import script from "./FormSelectMaterial.vue?vue&type=script&lang=js"
export * from "./FormSelectMaterial.vue?vue&type=script&lang=js"
import style0 from "./FormSelectMaterial.vue?vue&type=style&index=0&id=b01dbc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01dbc7a",
  null
  
)

export default component.exports